import http from '../../axios'
import store from '../../store'

export default {
  actions: {
    async scheduleReport({ commit }) {
      commit('setError', null)
      try {
        const response = await http.get('ticketing/api/v1/departments/all')
        if (response.data.success) {
          return {
            success: true,
            data: { ...response.data.data }
          }
        } else {
          commit('setError', response.data.error.message)
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          return {
            success: false,
            errors: { ...error.response.data.error.errors }
          }
        } else {
          commit('setError', error.message)
          return {
            success: false,
            errors: {}
          }
        }
      }
    },
    async exportReport({ commit }, { url, page, per_page }) {
      commit('setError', null)
      try {
        const response = await http.get(
          `${url.replace(
            'call-log-report?',
            'call-log-report/export?'
          )}&page=${page}&per_page=${per_page}&export=excel`,
          {
            responseType: 'arraybuffer'
          }
        )
        if (response.status == 200) {
          return response
        } else {
          commit('setError', response.data.error.message)
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          return {
            success: false,
            errors: { ...error.response.data.error.errors }
          }
        } else {
          commit('setError', error.message)
          return {
            success: false,
            errors: {}
          }
        }
      }
    },
    async scheduleReport({ commit }, model) {
      commit('setError', null)

      try {
        const response = await http.post(
          'sip/provisioningwa/api/v1/call-log-report/schedule',
          model
        )
        if (response.data.success) {
          return {
            success: true,
            data: response.data.data
          }
        } else {
          commit('setError', response.data.error.message)
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          return {
            success: false,
            errors: { ...error.response.data.error.errors }
          }
        } else {
          commit('setError', error.message)
          return {
            success: false,
            errors: {}
          }
        }
      }
    }
  }
}
